<template>
  <form
    class="w-full my-4 py-2 px-2 bg-grey-1 border-t border-b md:border border-grey-3 rounded-none md:rounded-lg"
    id="reply-create-form"
    @submit.prevent
  >
    <div class="mb-2">
      <nx-richtextarea v-model="body" :errors="form.errors" label="Reply To Thread" id="body" class="reply-create" ref="input" />
    </div>

    <div class="w-full flex items-center">
      <div class="flex-1 pl-1">
        <nx-button
          type="primary"
          :disabled="loading"
          @click="submit"
        >{{ loading ? 'Loading..' : 'Submit' }}</nx-button>
      </div>
      <div class="text-right text-sm pr-1">
        <a
          class="cursor-pointer text-blue-8 hover:text-blue-9 | keyboard-shorcuts"
          @click="show.shortcuts = true"
        >Keyboard Shortcuts</a>
      </div>
    </div>

    <portal to="modal-portal">
      <rich-text-shortcuts-modal v-if="show.shortcuts" @close="show.shortcuts = false"></rich-text-shortcuts-modal>
    </portal>
  </form>
</template>

<script>
import Form from "form-backend-validation"
import RichTextShortcutsModal from "@/components/Modals/RichTextShortcutsModal"
import { EventBus } from '@/events'

export default {
  name: "ReplyCreateForm",
  components: {
    RichTextShortcutsModal
  },
  data() {
    return {
      form: new Form(),
      loading: false,
      body: "",
      show: {
        shortcuts: false
      }
    }
  },
  methods: {
    async submit() {
      this.form.errors.clear()
      this.loading = true
      await this.$api.replies
        .create({ body: this.body })
        .then(({ data }) => {
          this.body = ""
          this.$emit("success", data)
        })
        .catch(data => {
          if (data.response && data.response.status === 422) {
            this.form.onFail(data)
            this.$error.form()
          }else if (data.response && data.response.status !== 429){
            this.$error.generic()
          }
        })
      this.loading = false
    }
  },
  mounted() {
    EventBus.$on('reply-with-quote', (item) => {
      let content = '<blockquote class="reply-quote"><div class="reply-quote-owner" contenteditable="false">' + item.owner.username + ' wrote...</div>' + item.body + '</blockquote>'
      this.$refs.input.addQuote(content)
      this.$refs.input.focusEditor()
      this.$scrollTo('#reply-create-form')
    })
  }
}
</script>

